import { Vault, Zero } from 'nftx.js';

export const getBestBuyPrice = (vaults?: Vault[]) => {
  const prices = vaults
    ?.map((v) => v.prices[0].redeem.price)
    .sort((a, b) => {
      if (a === b) {
        return 0;
      }
      if (a === Zero) {
        return 1;
      }
      if (b === Zero) {
        return -1;
      }
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

  const lowest = prices?.shift() ?? Zero;

  return lowest;
};

export const getBestSellPrice = (vaults?: Vault[]) => {
  const prices = vaults
    ?.map((v) => v.prices[0].mint.price ?? Zero)
    .sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

  const highest = prices?.pop() ?? Zero;

  return highest;
};

export const getTvl = (vaults?: Vault[]) => {
  const itemCount =
    vaults?.reduce((acc, cur) => cur.totalHoldings + acc, 0) || 0;
  const buyPrice = getBestBuyPrice(vaults) || 0;
  return Number(buyPrice) * itemCount;
};
